// Upcoming features — rendered as elegant "Coming Soon" pages.
export const UPCOMING = [
  {
    slug: "books", path: "/books", en: "Books & Manuscripts", hi: "ग्रंथ एवं पांडुलिपियाँ", icon: "BookMarked",
    desc_en: "A growing digital repository of sacred texts, scriptures and manuscripts — read, search and study the source works of the tradition.",
    desc_hi: "पवित्र ग्रंथों, शास्त्रों एवं पांडुलिपियों का बढ़ता डिजिटल संग्रह — मूल ग्रंथों को पढ़ें, खोजें एवं अध्ययन करें।",
  },
  {
    slug: "courses", path: "/courses", en: "Courses", hi: "पाठ्यक्रम", icon: "GraduationCap",
    desc_en: "Structured, authentic courses on scriptures, rituals and Sanskrit — learn step by step from qualified teachers.",
    desc_hi: "शास्त्र, कर्मकांड और संस्कृत पर प्रामाणिक, क्रमबद्ध पाठ्यक्रम — योग्य आचार्यों से क्रमशः सीखें।",
  },
  {
    slug: "veda-chanting", path: "/veda-chanting", en: "Chanting the Veda — Courses", hi: "वेद पाठ पाठ्यक्रम", icon: "AudioLines",
    desc_en: "Learn Vedic recitation — svara, chandas and pada — the traditional way, from the basics upward.",
    desc_hi: "स्वर, छंद एवं पद सहित पारंपरिक रीति से वेद पाठ मूल से सीखें।",
  },
  {
    slug: "crowdfunding", path: "/crowdfunding", en: "Crowdfunding for Temples", hi: "मंदिरों हेतु सामूहिक सहयोग", icon: "HandCoins",
    desc_en: "Support the restoration of temples and community religious activities through transparent crowdfunding.",
    desc_hi: "पारदर्शी सामूहिक सहयोग द्वारा मंदिरों के जीर्णोद्धार एवं धार्मिक कार्यों में योगदान।",
  },
  {
    slug: "anushthan", path: "/anushthan", en: "Participate & Support Anushthans", hi: "अनुष्ठानों में सहभागिता", icon: "HeartHandshake",
    desc_en: "Join, sponsor or contribute to yajnas and anushthans performed by traditional practitioners.",
    desc_hi: "पारंपरिक विद्वानों द्वारा किए जाने वाले यज्ञ एवं अनुष्ठानों में सहभागिता अथवा सहयोग करें।",
  },
  {
    slug: "discussions", path: "/discussions", en: "Discussions", hi: "चर्चा मंच", icon: "MessagesSquare",
    desc_en: "A respectful community space to discuss dharma, scriptures and living traditions.",
    desc_hi: "धर्म, शास्त्र एवं जीवंत परंपराओं पर सुसंगत चर्चा हेतु एक सम्मानजनक समुदाय।",
  },
  {
    slug: "qna", path: "/qna", en: "Questions & Answers", hi: "प्रश्न एवं उत्तर", icon: "HelpCircle",
    desc_en: "Ask your questions and receive answers grounded in scripture and tradition.",
    desc_hi: "शास्त्र एवं परंपरा पर आधारित उत्तर पाने हेतु अपने प्रश्न पूछें।",
  },
  {
    slug: "naming", path: "/naming", en: "Baby Names by Birth Details", hi: "जन्म विवरण अनुसार नामकरण", icon: "Baby",
    desc_en: "Discover auspicious names for boys and girls based on nakshatra and birth details.",
    desc_hi: "नक्षत्र एवं जन्म विवरण के आधार पर बालक-बालिकाओं हेतु शुभ नाम।",
  },
  {
    slug: "sankalpa", path: "/sankalpa", en: "Sankalpa", hi: "संकल्प", icon: "HandHeart",
    desc_en: "Take and record a sacred sankalpa — a resolve for your sadhana, vrata or observance.",
    desc_hi: "साधना, व्रत अथवा अनुष्ठान हेतु पवित्र संकल्प लें एवं संजोएँ।",
  },
  {
    slug: "namasmarana-groups", path: "/namasmarana-groups", en: "Namasmarana Groups", hi: "नामस्मरण समूह", icon: "Users",
    desc_en: "Join or start a group naam-japa — chant a shared mantra together and grow a collective tally.",
    desc_hi: "सामूहिक नाम-जप में सम्मिलित हों — साथ मिलकर मंत्र जपें एवं सामूहिक संख्या बढ़ाएँ।",
  },
  {
    slug: "puja-guidance", path: "/puja-guidance", en: "Pooja & Ritual Guidance", hi: "पूजा एवं अनुष्ठान परामर्श", icon: "Compass",
    desc_en: "Personalised guidance on which pooja, vrata or ritual is right for your intention — and how to perform it.",
    desc_hi: "आपके संकल्प हेतु उपयुक्त पूजा, व्रत अथवा अनुष्ठान एवं उसकी विधि पर व्यक्तिगत परामर्श।",
  },
  {
    slug: "sanskrit", path: "/sanskrit", en: "Sanskrit", hi: "संस्कृत", icon: "GraduationCap",
    desc_en: "Learn the sacred language of the tradition — alphabet, pronunciation, grammar and the reading of original texts, step by step.",
    desc_hi: "परंपरा की पवित्र भाषा सीखें — वर्णमाला, उच्चारण, व्याकरण एवं मूल ग्रंथों का पठन, क्रमशः।",
  },
  {
    slug: "live-darshan", path: "/live-darshan", en: "Live Darshan", hi: "लाइव दर्शन", icon: "Video",
    desc_en: "Live darshan and aarti streamed from the official channels of revered temples across Bharat — coming soon.",
    desc_hi: "भारत के पावन मंदिरों के आधिकारिक चैनलों से सीधा दर्शन एवं आरती — शीघ्र आ रहा है।",
  },
];

export const UPCOMING_BY_SLUG = Object.fromEntries(UPCOMING.map((u) => [u.slug, u]));
